module.exports = __webpack_public_path__ + "static/media/siderLogo.b1510a56.png";